import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { handlePausePlay, handleScreenShot, onBeforeJumpPage } from '@common/plugins/adReach';
import myPerformance from 'common/utils/myPerformance';
import { isRealOnline } from '@common/utils/env';
import { getCookie } from '@common/stores/cookie';

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@public/views/login.vue'),
  },
  {
    // 联合协议页面，用于承担各种协议展示的单独页面
    path: '/page-protocol',
    name: 'page-protocol',
    component: () => import('@public/views/page-protocol/index.vue'),
  },
  {
    path: '/addBank',
    name: '/npblic/addbank',
    component: () => import('@public/views/add-bank-new/addBank.vue'),
    meta: {
      title: '添加银行卡',
    },
    alias: ['/:terminal/bankcardManager/addbank'],
  },
  {
    path: '/addBankBackup',
    name: 'addBankBackup',
    meta: {
      spmPath: '/add-bank',
    },
    component: () => import('@public/views/add-bank/addBank.vue'),
  },
  {
    path: '/support',
    name: 'support',
    meta: {
      title: '支持的银行',
    },
    component: () => import('@public/views/support/support.vue'),
    alias: ['/:terminal/bankcardManager/support'],
  },
  {
    path: '/bankHotline',
    name: 'bankHotline',
    component: () => import('@public/views/bankHotline/bankHotline.vue'),
    meta: {
      title: '银行客服热线',
    },
    alias: ['/:terminal/bankcardManager/bankHotline'],
  },
  {
    path: '/addBankSecond',
    name: 'addBankSecond',
    component: () => import('@public/views/add-bank-second/addBankSecond.vue'),
    meta: {
      title: '添加银行卡',
      spmPath: '/add-bank-second',
    },
    alias: ['/:terminal/bankcardManager/addBankSecond'],
  },
  {
    path: '/newFillBankcard',
    name: 'newFillBankcard',
    meta: {
      spmPath: '/new-fill-bankcard',
    },
    component: () => import('@public/views/new-fill-bankcard/index.vue'),
  },
  // {
  //   path: '/accountMyBank',
  //   name: 'accountMyBank',
  //   component: () => import('@public/views/account-my-bank/index.vue'),
  //   meta: {
  //     title: '我的银行卡',
  //   },
  // },
  {
    path: '/setTrPwd',
    name: 'setTrPwd',
    meta: {
      spmPath: '/set-tr-pwd',
    },
    component: () => import('@public/views/set-tr-pwd/index.vue'),
  },
  {
    path: '/noAuthAddbank',
    name: 'noAuthAddbank',
    component: () => import('@public/views/noAuth-add-bank/index.vue'),
    meta: {
      title: '实名认证', // 原添加银行卡
      spmPath: '/noAuth-add-bank/sensors',
    },
  },
  {
    path: '/addContact',
    name: 'addContact',
    component: () => import('@public/views/add-contacts/index.vue'),
    meta: {
      title: '联系人信息',
      spmPath: '/add-contacts/sensors',
    },
  },
  {
    path: '/accountRepayManage',
    name: 'accountRepayManage',
    component: () => import('@public/views/my-bankcards/index.vue'),
    meta: {
      title: '还款账户管理',
      spmPath: '/my-bankcards',
    },
  },
  {
    path: '/myBankcards',
    name: 'myBankcards',
    component: () => import('@public/views/my-bankcards-nozd/index.vue'),
    meta: {
      title: '还款账户管理',
      spmPath: '/my-bankcards-nozd',
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@public/views/home/index.vue'),
    meta: {
      title: '个人中心',
    },
  },
  {
    path: '/dlreg',
    name: 'dlreg',
    component: () => import('@public/views/dl/dlsmslogin.vue'),
    meta: {
      title: '还款账户管理',
      spmPath: '/dl',
    },
  },
  {
    path: '/updateBankcardMobile',
    name: 'updateBankcardMobile',
    component: () => import('@public/views/updateBankcardMobile/updateBankcardMobile.vue'),
    meta: {
      title: '修改银行预留手机号',
    },
  },

  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName :error */ '@public/views/error/index.vue'),
  },
  // 人脸识别开始入口页面，入口老项目路由
  {
    path: '/checkFace',
    name: 'checkFace',
    component: () => import(/* webpackChunkName :loan */ '@public/views/checkFace/index.vue'),
    meta: {
      title: '人脸验证',
      hasSeleton: true,
    },
  },
  {
    path: '/faceFailNum',
    name: 'faceFailNum',
    component: () => import(/* webpackChunkName :loan */ '@public/views/faceFailNum/index.vue'),
    meta: {
      title: '人脸对比失败超次',
      hasSeleton: true,
    },
  },
  {
    path: '/faceAuthFail',
    name: 'faceAuthFail',
    component: () => import(/* webpackChunkName :loan */ '@public/views/faceAuthFail/index.vue'),
    meta: {
      title: '人工审核中',
      hasSeleton: true,
    },
  },
  // 新的设置交易密码页面 已经通过了人脸识别验证（开流之前要修改老项目页面）
  {
    meta: {
      title: '设置交易密码',
      spmPath: '/loanPwd',
    },
    path: '/setLoanPwd',
    name: 'setLoanPwd',
    component: () => import('@public/views/loanPwd/loanPwd.vue'),
  },
  {
    meta: {
      title: '借款指南',
      spmPath: '/activity/loan-guide',
    },
    path: '/loanGuide',
    name: 'loanGuide',
    component: () => import('@public/views/activity/loan-guide/index.vue'),
  },
  {
    meta: {
      title: '征信授权协议',
    },
    path: '/checkCredit',
    name: 'checkCredit',
    component: () => import('@public/views/checkCredit/index.vue'),
  },
  {
    meta: {
      title: '设置交易密码',
    },
    path: '/checkLoanPwd',
    name: 'checkLoanPwd',
    component: () => import('@public/views/checkLoanPwd/index.vue'),
  },
  {
    path: '/safe/checkMobile',
    name: 'checkMobile',
    meta: {
      title: '修改登录密码',
      spmPath: '/check-mobile',
    },
    component: () => import('@public/views/check-mobile/index.vue'),
  },
  {
    meta: {
      title: '修改注册手机号', // 未登录
    },
    path: '/modifyMobileIdcard',
    name: 'modifyMobileIdcard',
    component: () => import('@public/views/modify-mobile/modifyMobileIdcard/index.vue'),
  },
  {
    meta: {
      title: '修改注册手机号', // 已登录
    },
    path: '/modifyMobileNum',
    name: 'modifyMobileNum',
    component: () => import('@public/views/modify-mobile/modifyMobileNum/index.vue'),
  },
  {
    path: '/modifyMobileFaceResult',
    name: '/modifyMobileFaceResult',
    meta: {
      title: '人脸识别成功',
    },
    component: () => import('@public/views/modify-mobile/face-result/index.vue'),
  },
  {
    path: '/modifyMobileResult',
    name: '/modifyMobileResult',
    meta: {
      title: '修改结果',
    },
    component: () => import('@public/views/modify-mobile/result-page/index.vue'),
  },
  {
    path: '/safe/face',
    name: 'face',
    meta: {
      title: '人脸验证',
    },
    component: () => import('@public/views/face/index.vue'),
  },
  {
    meta: {
      title: '设置新密码',
      spmPath: '/set-new-login-pwd',
    },
    path: '/setNewLoginPwd',
    name: 'setNewLoginPwd',
    component: () => import('@public/views/set-new-login-pwd/index.vue'),
  },
  {
    meta: {
      title: '合同及协议',
      spmPath: '/contract-agreements',
    },
    path: '/contractAgreements',
    name: 'contractAgreements',
    component: () => import('@public/views/contract-agreements/index.vue'),
  },
  {
    meta: {
      title: '合同列表',
    },
    path: '/loanContract',
    name: 'loanContract',
    component: () => import('@public/views/contract-agreements/loanContract.vue'),
  },
  {
    meta: {
      title: '借据详情',
    },
    path: '/billReceipt',
    name: 'billReceipt',
    component: () => import('@public/views/contract-agreements/billReceipt.vue'),
  },
  {
    meta: {
      title: '合同列表', // 联合放款借据合同
    },
    path: '/unionLoanDetailList',
    name: 'unionLoanDetailList',
    component: () => import('@public/views/contract-agreements/unionLoanDetailList.vue'),
  },
  {
    meta: {
      title: '合同列表', // 马上全资放款借据合同
    },
    path: '/msLoanDetailList',
    name: 'msLoanDetailList',
    component: () => import('@public/views/contract-agreements/msLoanDetailList.vue'),
  },
  {
    meta: {
      title: '借款履约保证保险电子保单',
    },
    path: '/billInsure',
    name: 'billInsure',
    component: () => import('@public/views/contract-agreements/billInsure.vue'),
  },
  {
    meta: {
      title: '银行卡相关协议',
    },
    path: '/bank',
    name: 'bank',
    component: () => import('@public/views/contract-agreements/bank.vue'),
  },
  {
    meta: {
      title: '银行卡相关协议',
    },
    path: '/bankCardAgreement',
    name: 'bankCardAgreement',
    component: () => import('@public/views/contract-agreements/bankCardAgreement.vue'),
  },
  {
    meta: {
      title: '个人信息授权书',
    },
    path: '/personInfoAuth',
    name: 'personInfoAuth',
    component: () => import('@public/views/contract-agreements/personInfoAuth.vue'),
  },
  {
    meta: {
      title: '委托担保服务协议',
    },
    path: '/entrustedGuarantee',
    name: 'entrustedGuarantee',
    component: () => import('@public/views/contract-agreements/entrustedGuarantee.vue'),
  },
  {
    meta: {
      title: '委托担保',
    },
    path: '/entrustedGuaranteeDetail',
    name: 'entrustedGuaranteeDetail',
    component: () => import('@public/views/contract-agreements/entrustedGuaranteeDetail.vue'),
  },
  {
    meta: {
      title: '生活服务相关协议',
    },
    path: '/yiliMember',
    name: 'yiliMember',
    component: () => import('@public/views/contract-agreements/yiliMember.vue'),
  },
  {
    meta: {
      title: '合同/协议列表',
    },
    path: '/schedule',
    name: 'schedule',
    component: () => import('@public/views/contract-agreements/schedule.vue'),
  },
  {
    meta: {
      title: '合同/协议列表',
    },
    path: '/scheduleDetail',
    name: 'scheduleDetail',
    component: () => import('@public/views/contract-agreements/scheduleDetail.vue'),
  },
  {
    path: '/changeBank',
    name: 'changeBank',
    meta: {
      title: '更换银行卡',
    },
    component: () => import('@public/views/change-bank/index.vue'),
  },
  {
    meta: {
      title: '锁期还款确认书',
    },
    path: '/repayConfirmLetter',
    name: 'repayConfirmLetter',
    component: () => import('@public/views/contract-agreements/repayConfirmLetter.vue'),
  },
  {
    meta: {
      title: '锁期还款确认书列表',
    },
    path: '/repayConfirmLetterList',
    name: 'repayConfirmLetterList',
    component: () => import('@public/views/contract-agreements/repayConfirmLetterList.vue'),
  },
  {
    meta: {
      title: '征信授权相关协议列表',
    },
    path: '/auth',
    name: 'auth',
    component: () => import('@public/views/contract-agreements/auth.vue'),
  },
  {
    meta: {
      title: '协议详情列表',
    },
    path: '/agreementDetail',
    name: 'agreementDetail',
    component: () => import('@public/views/contract-agreements/agreementDetail.vue'),
  },
  {
    meta: {
      title: '隐私说明',
    },
    path: '/privacyfile',
    name: 'privacyfile',
    component: () => import('@public/views/contract-agreements/privacyfile.vue'),
  },
  {
    path: '/creditHome',
    name: 'creditHome',
    meta: {
      title: '消费凭证',
      spmPath: '/credit-home',
    },
    component: () => import('@public/views/credit-home/index.vue'),
  },
  {
    path: '/jdBackR3G/:path',
    name: 'jdBackR3G',
    meta: {
      title: ' ', // r3g 京东绑卡中转页面
    },
    component: () => import('@public/views/jdBackR3G/index.vue'),
  },
  {
    meta: {
      title: '设置新密码',
      spmPath: '/set-new-login-pwd-without-checked',
    },
    path: '/setNewLoginPwdWithoutChecked',
    name: 'setNewLoginPwdWithoutChecked',
    component: () => import('@public/views/set-new-login-pwd-without-checked/index.vue'),
  },
  {
    meta: {
      title: '增信资料中心',
    },
    path: '/credit/center',
    name: 'creditCenter',
    component: () => import('@public/views/credit/center/index.vue'),
  },
  {
    meta: {
      title: '微信账单认证',
    },
    path: '/credit/wx-bill',
    name: 'creditWxBill',
    component: () => import('@public/views/credit/wx-bill/index.vue'),
  },
  {
    meta: {
      title: '支付宝账单认证',
    },
    path: '/credit/ali-bill',
    name: 'creditAliBill',
    component: () => import('@public/views/credit/ali-bill/index.vue'),
  },
  {
    meta: {
      title: '上传营业执照',
    },
    path: '/credit/business',
    name: 'creditBusiness',
    component: () => import('@public/views/credit/business/index.vue'),
  },
  {
    path: '/statuteCase',
    name: 'statuteCase',
    meta: {
      title: '司法判决案例',
      spmPath: '/static-page/statute-case',
    },
    component: () => import('@public/views/static-page/statute-case/index.vue'),
  },
  {
    path: '/overdueImpact',
    name: 'overdueImpact',
    meta: {
      title: '', //逾期影响
      spmPath: '/static-page/overdue-impact',
    },
    component: () => import('@public/views/static-page/overdue-impact/index.vue'),
  },
  {
    meta: {
      title: '上传身份证照片',
    },
    path: '/uploadId',
    name: 'uploadId',
    component: () => import('@public/views/uploadId/index.vue'),
  },
  {
    meta: {
      title: '上传身份证照片',
    },
    path: '/uploadIdCard',
    name: 'uploadIdCard',
    component: () => import('@public/views/uploadIdCard/index.vue'),
  },

  {
    path: '/idHelp',
    name: 'idHelp',
    meta: {
      title: '人脸识别常见问题', //ocr帮助页面
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/idHelp/index.vue'),
  },
  {
    path: '/mslogin',
    name: 'mslogin',
    component: () => import('@public/views/mslogin/mslogin.vue'),
  },
  {
    path: '/downloadGuide',
    name: 'downloadGuide',
    meta: {
      title: 'APP下载', //help下载引导页
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/downloadGuide/index.vue'),
  },
  {
    path: '/consumerHome',
    name: 'consumerHome',
    meta: {
      title: '消费者之家', //消费者之家
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/consumer-home/index.vue'),
  },
  {
    path: '/billNuclearGuide',
    name: 'billNuclearGuide',
    meta: {
      title: '身份认证', //消费者之家
    },
    component: () =>
      import(
        /* webpackChunkName :billNuclearGuide */ '@public/views/repay-nuclear-guide/index.vue'
      ),
  },
  {
    path: '/consumerArticleDetail',
    name: 'consumerArticleDetail',
    meta: {
      title: '', //消费者之家文章详情
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/consumer-home/detail.vue'),
  },
  {
    path: '/downloadPage',
    name: 'downloadPage',
    meta: {
      title: '下载页', //下载引导页
    },
    // 动态路由页面
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/download-page/dynamicLayout.vue'),
    // component: () => import(/* webpackChunkName :error */ '@public/views/download-page/index.vue'),
  },
  {
    path: '/dlFaceVerification',
    name: 'dlFaceVerification',
    meta: {
      title: '身份认证',
    },
    component: () => import('@public/views/dlFaceVerification/index.vue'),
  },
  {
    path: '/dlBankVerification',
    name: 'dlBankVerification',
    component: () => import('@public/views/dlFaceVerification/bankVerification/index.vue'),
    meta: {
      title: '实名认证',
    },
  },
  {
    path: '/:channel/dlreg/:section?',
    name: 'dllogin',
    component: () => import('@public/views/dl/dlsmslogin.vue'),
    meta: {
      title: '顺逸花登录/注册',
    },
  },
  {
    path: '/addContactCommon',
    name: 'addContactCommon',
    component: () => import('@public/views/add-contact-common/index.vue'),
    meta: {
      title: '补充联系人',
      hasEmergency: true, // 与补充本人信息用同一个页面，用于区分
    },
  },
  {
    path: '/myContactInfoAdd',
    name: 'myContactInfoAdd',
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/contractInfo/contractAdd/index.vue'),
    meta: {
      title: '填写联系人信息',
    },
  },
  {
    path: '/myContactInfoEntry',
    name: 'myContactInfoEntry',
    meta: {
      title: '我的联系人信息',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/contractInfo/contractEntry/index.vue'),
  },
  {
    path: '/myContactInfoEdit',
    name: 'myContactInfoEdit',
    meta: {
      title: '编辑联系人信息',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/contractInfo/contractEdit/index.vue'),
  },
  {
    path: '/addPhoneCommon',
    name: 'addPhoneCommon',
    component: () => import('@public/views/add-contact-common/index.vue'),
    meta: {
      title: '补充本人信息',
    },
  },
  {
    path: '/realNameAuth',
    name: 'realNameAuth',
    component: () => import('@public/views/real-name-auth/index.vue'),
    meta: {
      title: '实名认证',
    },
  },
  {
    path: '/realNameAuth/result',
    name: 'realNameAuthResult',
    component: () => import('@public/views/real-name-auth-result/index.vue'),
    meta: {
      title: '认证结果',
    },
  },
  {
    path: '/addAlipaySign',
    name: 'addAlipaySign',
    component: () => import('@public/views/add-alipay-sign/index.vue'),
    meta: {
      title: '支付宝签约授权',
    },
  },
  {
    path: '/addAlipaySignSuccess',
    name: 'addAlipaySignSuccess',
    component: () => import('@public/views/add-alipay-sign-success/index.vue'),
    meta: {
      title: '支付宝签约结果',
    },
  },
  {
    meta: {
      title: '预约借款申请规则',
    },
    path: '/appointmentLoan',
    name: 'appointmentLoan',
    component: () => import('@public/views/contract-agreements/appointmentLoan.vue'),
  },
  {
    meta: {
      title: '优惠券使用确认函列表',
    },
    path: '/couponConfirmLetter',
    name: 'couponConfirmLetter',
    component: () => import('@public/views/contract-agreements/couponConfirmLetter.vue'),
  },
  {
    meta: {
      title: '增信中心问卷调研',
    },
    path: '/credit/ursSuccess',
    name: 'ursSuccess',
    component: () => import('@public/views/credit/urs-success/index.vue'),
  },
  {
    meta: {
      title: '银行流水认证',
    },
    path: '/credit/bankBill',
    name: 'creditBank',
    component: () => import('@public/views/credit/bank-bill/index.vue'),
  },
  {
    meta: {
      title: '上传微信支付分',
    },
    path: '/credit/wechat',
    name: 'creditWechat',
    component: () => import('@public/views/credit/wechat/index.vue'),
  },
  {
    meta: {
      title: '上传芝麻分',
    },
    path: '/credit/zhima',
    name: 'creditZhima',
    component: () => import('@public/views/credit/zhima/index.vue'),
  },
  {
    meta: {
      title: '微信账单认证',
    },
    path: '/credit/wxBill',
    name: 'creditWxBill',
    component: () => import('@public/views/credit/wx-bill/index.vue'),
  },
  {
    meta: {
      title: '支付宝账单认证',
    },
    path: '/credit/aliBill',
    name: 'creditAliBill',
    component: () => import('@public/views/credit/ali-bill/index.vue'),
  },
  {
    meta: {
      title: '上传行驶证',
    },
    path: '/credit/drive',
    name: 'creditDrive',
    component: () => import('@public/views/credit/drive/index.vue'),
  },
  {
    meta: {
      title: '上传房产证',
    },
    path: '/credit/house',
    name: 'creditHouse',
    component: () => import('@public/views/credit/house/index.vue'),
  },
  {
    path: '/downQrCode',
    name: 'downQrCode',
    meta: {
      title: '下载马上金融APP',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/qr-code/index.vue'),
  },
  {
    path: '/guideDownApp', //help迁移过来的下载页
    name: 'guideDownApp',
    meta: {
      title: '',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/guide-down-app/index.vue'),
  },
  {
    path: '/logout/home',
    name: 'logoutHome',
    meta: {
      title: '账户注销',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/logout/home/index.vue'),
  },
  {
    path: '/logout/holdMarketing',
    name: 'holdMarketing',
    meta: {
      title: '屏蔽营销',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/logout/holdMarketing/index.vue'),
  },
  {
    path: '/logout/verifyCredentialsPage',
    name: 'verifyCredentialsPage',
    meta: {
      title: '身份验证',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/logout/verifyCredentialsPage/index.vue'),
  },
  {
    path: '/logout/result',
    name: 'logoutResult',
    meta: {
      title: '注销结果',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/logout/result/index.vue'),
  },
  {
    path: '/logout/entry',
    name: 'logoutEntry',
    meta: {
      title: '注销账号',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/logout/entry/index.vue'),
  },
  {
    path: '/logout/equity',
    name: 'logoutEquity',
    meta: {
      title: '注销账号',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/logout/equity/index.vue'),
  },
  {
    path: '/logout/investigate',
    name: 'logoutInvestigate',
    meta: {
      title: '注销调研',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/logout/investigate/index.vue'),
  },
  {
    path: '/protocolPage',
    name: 'protocolPage',
    meta: {
      title: '协议展示',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/page-protocol/new.vue'),
  },
  {
    path: '/personalizeSetting',
    name: 'personalizeSetting',
    meta: {
      title: '个性化选项',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/personalize-setting/index.vue'),
  },
  {
    path: '/accountManagement/harmony',
    name: 'harmonyLoading',
    meta: {
      title: ' ',
    },
    component: () =>
      import(
        /* webpackChunkName :error */ '@public/views/account-management/harmony-loading/index.vue'
      ),
  },
  {
    path: '/loanPurposeConfirm',
    name: 'loanPurposeConfirm',
    meta: {
      title: '贷款用途信息确认',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/loan-purpose-confirm/index.vue'),
  },
  {
    path: '/idcardUpdate/error',
    name: 'idCardUpdateError',
    meta: {
      title: '上传身份证', // 身份证有效期更新失败
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/idcard-update/error/index.vue'),
  },
  {
    path: '/checkFaceCommon',
    name: 'checkFaceCommon',
    meta: {
      title: '人脸识别',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/checkFace/checkFace.vue'),
  },
  {
    meta: {
      title: '人脸识别常见问题',
    },
    path: '/checkFaceHelp',
    name: 'checkFaceHelp',
    component: () => import('@public/views/checkFace/checkFaceHelp.vue'),
  },
  {
    path: '/appAuthRiskControl',
    name: 'appAuthRiskControl',
    meta: {
      title: '人脸识别', // APP登录风险管控-高风险用户 人脸
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/appAuthRiskControl/index.vue'),
  },
  {
    meta: {
      title: '',
    },
    path: '/modifyLoginPwd/entry',
    name: 'modifyLoginPwdEntry',
    component: () => import('@public/views/modify-login-pwd/entry/index.vue'),
  },
  {
    meta: {
      title: '修改登录密码',
    },
    path: '/modifyLoginPwd/checkUserInfo',
    name: 'modifyLoginPwdCheckUserInfo',
    component: () => import('@public/views/modify-login-pwd/checkUserInfo/index.vue'),
  },
  {
    meta: {
      title: '人脸识别',
    },
    path: '/modifyLoginPwd/checkFace',
    name: 'modifyLoginPwdCheckFace',
    component: () => import('@public/views/modify-login-pwd/checkFace/index.vue'),
  },
  {
    meta: {
      title: '修改登录密码',
    },
    path: '/modifyLoginPwd/verifyBankCard',
    name: 'modifyLoginPwdVerifyBankCard',
    component: () => import('@public/views/modify-login-pwd/verifyBankCard/index.vue'),
  },
  {
    meta: { title: '身份证信息更新列表页' },
    path: '/modifyName/list',
    name: 'modifyNameList',
    component: () => import('@public/views/modify-name/list/index.vue'),
  },
  {
    meta: {
      title: '变更信息输入页',
    },
    path: '/modifyName/userInfo',
    name: 'modifyNameUserInfo',
    component: () => import('@public/views/modify-name/userInfo/index.vue'),
  },
  {
    meta: {
      title: '身份证照片上传',
    },
    path: '/modifyName/uploadIdCard',
    name: 'modifyNameUploadIdCard',
    component: () => import('@public/views/modify-name/uploadIdCard/index.vue'),
  },
  {
    meta: {
      title: '身份信息确认页',
    },
    path: '/modifyName/changeUserSure',
    name: 'modifyNameChangeUserSure',
    component: () => import('@public/views/modify-name/changeUserSure/index.vue'),
  },
  {
    meta: {
      title: '身份信息修改承诺函',
    },
    path: '/modifyName/commitmentLetter',
    name: 'modifyNameCommitmentLetter',
    component: () => import('@public/views/modify-name/commitmentLetter/index.vue'),
  },
  {
    meta: {
      title: '身份信息更新审核中',
    },
    path: '/modifyName/success',
    name: 'modifyNameSuccess',
    component: () => import('@public/views/modify-name/success/index.vue'),
  },
  {
    path: '/officialPartner',
    name: 'officialPartner',
    meta: {
      title: '合作方官网',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/official-partner/index.vue'),
  },
  {
    path: '/personInfo/list',
    name: 'personInfoList',
    meta: {
      title: '个人信息清单',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/personInfo/list/index.vue'),
  },
  {
    path: '/personInfo/verify',
    name: 'personInfoListVerify',
    meta: {
      title: '验证方式选择',
    },
    component: () =>
      import(/* webpackChunkName: "verify-page" */ '@public/views/personInfo/list/verify.vue'),
  },
  {
    path: '/personInfo/export',
    name: 'personInfoExport',
    meta: {
      title: '个人信息导出',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/personInfo/export/index.vue'),
  },
  {
    path: '/personInfo/base',
    name: 'personInfoExportBase',
    meta: {
      title: '身份信息',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/personInfo/base/index.vue'),
  },
  {
    path: '/personInfo/down',
    name: 'personInfoExportDown',
    meta: {
      title: '个人信息导出',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/personInfo/down/index.vue'),
  },
  {
    path: '/personInfo/browser',
    name: 'personInfoBrowser',
    meta: {
      title: ' ',
    },
    component: () =>
      import(/* webpackChunkName :error */ '@public/views/personInfo/down/browser.vue'),
  },
  {
    path: '/ticket',
    name: 'ticket',
    meta: {
      title: '申请开票',
    },
    component: () => import(/* webpackChunkName :error */ '@public/views/ticket/index.vue'),
  },
  {
    path: '/closeIframe',
    name: 'closeIframe',
    component: () =>
      import(/* webpackChunkName :loaning */ '@public/views/adp-iframe-close/index.vue'),
    meta: {
      title: '加载中...',
    },
  },
  {
    path: '/todoList',
    name: '/todoList',
    meta: {
      title: '待办事项',
    },
    component: () => import('@public/views/todo-list/index.vue'),
  },
  {
    path: '/threeVerification',
    name: 'threeVerification',
    component: () => import('@public/views/threeVerification/index.vue'),
    meta: {
      title: '身份认证',
    },
  },
  {
    path: '/threeVerificationResult',
    name: 'threeVerificationResult',
    component: () => import('@public/views/threeVerification/result/index.vue'),
    meta: {
      title: '认证结果',
    },
  },
];

if (!isRealOnline()) {
  routes.push({
    path: '/adpTools',
    name: 'adpTools',
    meta: {
      title: 'adp测试工具',
    },
    component: () => import(/* webpackChunkName :error */ '@mock/views/tools/adp-tools.vue'),
  });
  routes.push({
    path: '/',
    name: 'login',
    component: () => import('@public/views/login.vue'),
  });
  routes.push({
    path: '/demo',
    name: 'demo',
    component: () => import('@mock/views/demo/index.vue'),
  });
}
routes.push({
  path: '/*',
  name: '404',
  redirect(to) {
    return {
      path: '/error',
      query: {
        type: '404',
      },
    };
  },
});

const _routesMap = {};
routes.forEach((item) => {
  if (item.name) {
    if (_routesMap[item.name]) {
      _routesMap[item.name].push(item);
    } else {
      _routesMap[item.name] = [item];
    }
  }
});
Object.keys(_routesMap).forEach((key) => {
  if (_routesMap[key].length > 1) {
    console.log(key, _routesMap[key]);
  }
});

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  base: '/npublic',
  routes,
});

// 暂时分开单独实现，后续收到common里
router.afterEach(async () => {
  window['toggleSeleton']('none');
  onBeforeJumpPage();
});

router.beforeEach(async (to, from, next) => {
  myPerformance.pageBeforeEach();
  window['toggleSeleton']('block');
  // if (!getCookie('vtoken') && process.env.NODE_ENV !== 'development') {
  //   location.href = `/npublic/error?type=3`;
  // }
  /* 路由发生变化修改页面title */
  if (to?.meta?.title) {
    document.title = to.meta.title;
  }
  // 安卓防截屏 获取spm_pid
  const path = to?.meta?.spmPath || to.path; // 获取dRow.json path
  if (path) {
    const getPid = async (path) => {
      let pId = '';
      try {
        const dRow = (await import(`@public/views${path}/dRow.json`)) ?? {};
        pId = dRow?.GLOBAL?.p_id;
      } catch (err) {
        pId = '';
      }
      return pId;
    };
    getPid(path).then(handleScreenShot);
  }
  handlePausePlay();
  next();
});

export default router;
